<template>
    <div class="min-h-[50svh]">
        <div class="container">
            <div class="relative md:border-x -mx-7.5 md:m-0 border-b"
            :class="store.postType === 'event' ? 'border-grey' : 'border-dark-grey' ">
                <!-- Loading spinner -->
                <div class="absolute top-6 left-6 md:top-12 md:left-12 spinner z-40" v-if="store.isLoading"></div>

                <div class="p-6 lg:p-12" v-show="store.hasNoResults">
                    <p>No results, please try fewer filters.</p>
                </div>

                <!-- Loading overlay -->
                <Transition name="fade">
                    <div class="absolute w-full h-full bg-(--area-bg)! z-20" v-show="store.isLoading"></div>
                </Transition>

                <div class="min-h-[50svh]">
                    <div v-if="layoutMode === 'grid'" class="grid md:grid-cols-2 xl:grid-cols-3">
                        <component :is="getComponentName" v-for="(item, index) in localItems" :key="item.__key" :item="item" :data-index="index" />
                    </div>
                    <div v-else class="grid">
                        <component :is="getComponentName" v-for="(item, index) in localItems" :key="item.__key" :item="item" :data-index="index" />
                    </div>
                </div>

                <Pagination v-if="store.showPagination" v-model="store.currentPage" :max-page="store.last_page" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch, computed } from "vue";
import EventGrid from "@facet/components/tiles/EventGrid.vue";
import EventList from "@facet/components/tiles/EventList.vue";
import MediapostGrid from "@facet/components/tiles/MediapostGrid.vue";
import MediapostList from "@facet/components/tiles/MediapostList.vue";
import Pagination from "@facet/global/Pagination.vue";
import { useFeedStore } from "@facet/utils/store.js";

const store = useFeedStore();

const props = defineProps({
    items: {
        type: Array,
        required: true,
    },
});

const layoutMode = computed(() => {
    return store.layout;
});

const getComponentName = computed(() => {
    return {
        event: { grid: EventGrid, list: EventList },
        mediapost: { grid: MediapostGrid, list: MediapostList },
    }[store.postType]?.[layoutMode.value];
});

const localItems = ref([...props.items]);

watch(
    () => props.items,
    (newItems) => {
        localItems.value = [...newItems];
    },
);

watch(
    () => store.currentPage,
    () => {
        store.fetchItems();
    },
);
</script>

<style>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.33s ease-in-out;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.slide-enter-active,
.slide-leave-active {
    transition: all 0.33s ease-in-out;
}

.slide-enter-from,
.slide-leave-to {
    opacity: 0;
    transform: translateY(-20px);
}
</style>
